<template>
  <header :class="$style.root">
    <div :class="$style.container">
      <div :class="[$style.column, $style.linkToClose]" v-if="$slots.linkToClose">
        <slot name="linkToClose" />
      </div>
      <div :class="[$style.column, $style.content]">
        <slot name="content" />
      </div>
      <div :class="$style.stroke" />
      <slot name="information" />
    </div>
  </header>
</template>

<script lang="ts" setup>
  const props = defineProps({
    page: {
      type: Object
    }
  })
</script>

<style module lang="scss">
  .root {
    padding: 0 var(--unit--default) 0 var(--unit--default);

    margin-bottom: var(--unit--vertical);

    @media (max-width: $breakpoint-s) {
      padding-top: 0;
      word-break: break-word;
    }
  }

  .container {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: var(--unit--spacer);
    grid-template-areas: 'content content'
                         'information information';

    &:has(.linkToClose) {
      grid-template-areas: 'content close'
                           'information information';
      grid-template-columns: 1fr min-content;
    }
  }

  .content {
    grid-area: content;
  }

  .stroke {
    margin-left: calc((var(--unit--default) / 2) * -1);
    margin-right: calc((var(--unit--default) / 2) * -1);

    /* NOTE UNIFY */
    border-bottom: var(--stroke--medium) solid;
    padding-bottom: calc(var(--stroke--medium) * 2);

    grid-column: 1 / -1;
  }

  .linkToClose {
    grid-area: close;
  }
</style>
